<template>
  <b-modal
    id="addSkillModal"
    v-model="open"
    size="sm"
    title="Add A Skill"
    ok-title="save"
    ok-variant="primary"
    @ok="save"
    cancel-title="Cancel"
    cancel-variant="text"
  >
    <label>Skill Name: </label>
    <b-form-input v-model="skill.name" />
  </b-modal>
</template>
<script>
import Skill from '@/fstore/collections/Skill';
import User from '@/fstore/collections/User';

export default {
  name: 'addSkill',
  props: {
    trigger:{
      default: () => {
        return false;
      }
    }
  },
  computed: {
    open: {
      get: function () {
        return this.trigger
      },
      set: function (value) {
        this.$emit('triggerUpdate', value)
      }
    }
  },
  data () {
    return {
      skill: Skill.getTemplate()
    }
  },
  methods: {
    async save() {
      try{
        this.$store.dispatch('app/setOverlay', true);
        this.skill.dateAdded = new Date();
        this.skill.addedBy = await User.getRef(this.$store.state.auth.data.uid);
        await Skill.create(this.skill);

        this.skill = Skill.getTemplate();
        this.$store.dispatch('app/setOverlay', false);
      }catch(err) {
        this.$store.dispatch('app/setOverlay', false);
      }
    }
  }
}
</script>